import React from 'react';
import AuthForm from '../common/authForm/AuthForm';
import { resendOtp, verifyOtp } from '../../api/authApi';
import ReactNotifications, { showApiErrors } from '../common/reactNotifications/ReactNotifications';
import { sucessState200 } from '../../utils/constants/utilsConstants';
import { useNavigate } from 'react-router-dom';

const OtpVerification = () => {
    const navigate = useNavigate();
    const email = sessionStorage.getItem('userEmail');

    const handleSubmit = (values, callback) => {
        const payload = {
            email,
            otp: values.otp,
        };
        verifyOtp(payload, callback);
    };

    const handleResendOtp = () => {
        const payload = {
            email,
        };
        resendOtp(payload, (res) => {
            if (res.status === true) {
                ReactNotifications(res.message, sucessState200);
            } else {
                showApiErrors(res);
            }
        });
    };

  const IsValidOtpData = (data) => {
    const errors = {};

    if (!data.otp) {
        errors.otp = 'OTP is required';
    } else {

        const otp = data.otp.toString().trim();
    
        if (!/^\d+$/.test(otp)) {
            errors.otp = 'OTP must contain only numbers';
        }
        
        else if (otp.length < 4 || otp.length > 6) {
            errors.otp = 'OTP must be between 4 and 6 digits';
        }
    }
    
    return {
        isValid: Object.keys(errors).length === 0,
        errors,
    };
};

    const customFields = [
        {
            name: "otp",
            type: "text",
            placeholder: "Enter OTP",
            label: "OTP",
        },
    ]

    return (
        <AuthForm
            formType="OTP-Verification"
            title="OTP Verification"
            subTitle="Enter the OTP sent to your email"
            initialValues={{ otp: "" }}
            validationFunc={IsValidOtpData}
            onSubmit={handleSubmit}
            successRedirectPath="/login"
            buttonLabel="Verify"
            loadingLabel="Verifying..."
            customLinks={[
                { to: "#", label: "Resend OTP", onClick: handleResendOtp },
                { to: "/login", label: "Back to Login" },
            ]}
            customFields={customFields}
        />
    );
};

export default OtpVerification;